/* 异步 */
export default {
  // 设置菜单隐藏或显示
  setIsCollapse({ commit }, isCollapse) {
    commit('UPDATE_ISCOLLAPSE', isCollapse);
  }
}